export const isMultiLine = (text: string) => text.includes('\n');
